import { IInitialState } from './interface';
import produce from 'immer';
import {
    CHANGE_CAPACITY,
    CHANGE_COLOR,
    SET_ATOMIC_ID,
} from './constants';

/**
 * Initial state
 */
export const initialState: IInitialState = {
    currentColor: undefined,
    currentCapacity: undefined,
    atomicId: undefined,
    forceRerender: true,
};

/**
 * Hardware detail reducer
 * @param state
 * @param action
 */
const optionsReducer = (state: any = initialState, action: any) =>
    produce(state, (draft: IInitialState) => {
        switch (action.type) {
            case CHANGE_COLOR:
                draft.currentColor = action.value;
                break;
            case CHANGE_CAPACITY:
                draft.currentCapacity = action.value;
                break;
            case SET_ATOMIC_ID:
                draft.atomicId = action.atomicId;
                draft.forceRerender = action.forceRerender;
                break;
        }
    });

export default optionsReducer;
